import { productSearchService } from "../../services/productSearchService";
import type { ManagedStrategySearchItem } from "../../types/productV3";

// Profile-derived matches always resolve through the live investor catalog.
// Fixed showcase products use alphaManagedStrategyConfig through the separate
// recommendation loader and must never leak into this shared match path.
export async function getAlphaManagedStrategyByMixId(
  mixId: string,
  signal?: AbortSignal
): Promise<ManagedStrategySearchItem> {
  return productSearchService.getManagedStrategyByMixIdForInvestor(
    mixId.trim(),
    signal
  );
}
